module.exports = __webpack_public_path__ + "img/category_1.97361f8a.svg";